window.tinymce.PluginManager.add('upload_audio', function(editor) {
    editor.addButton('upload_audio', function() {
        function showDialog() {
            editor.windowManager.open(
                {
                    title: 'بارگذاری فایل صوتی',
                    width: 600,
                    height: 215,
                    file: window.hashed_paths['tinymce_upload_audio.html'],
                },
            );
        }

        return {
            tooltip: 'بارگذاری فایل صوتی',
            onclick: showDialog,
            icon: 'custom fa-cloud-upload',
        };
    });
});
